import React from "react";

import { Img } from "components";

const Star = (props) => {
  return (
    <>
      <div className={props.className}>
        <div className="flex flex-col items-center justify-start w-7 md:w-full">
          <Img
            className="h-[27px] w-7"
            src="images/img_star5.svg"
            alt="starFive"
          />
        </div>
      </div>
    </>
  );
};

Star.defaultProps = {};

export default Star;
